import qs from "qs";

function queryParamsParse(str, options = {}) {
    return qs.parse(str, { comma: true, allowDots: true, ignoreQueryPrefix: true, ...options });
}

export default queryParamsParse;
